import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { RateSelection } from "@/apps/partner/components/Rates/RateSelection";
import { AddDeviceFormType } from "@/apps/partner/types";
import {
  partnerAddDeviceStepMapping,
  partnerAddDeviceStepPaths,
} from "@/apps/partner/utils/partnerAddDevice.constants";
import { usePartnerAddDeviceContext } from "@/apps/partner/views/AddDevice/PartnerAddDeviceContext";
import { Button } from "@/components/Interface/Button/Button";
import { StepFlowNavigation } from "@/components/Layout/BaseLayouts/StepFlowLayout/StepFlowNavigation";

export const PartnerRateStep = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setAllowedMaxStep } = usePartnerAddDeviceContext();
  const { watch, trigger } = useFormContext<AddDeviceFormType>();
  const productId = watch("productId");
  const simAlias = watch("simAlias");

  const handleContinue = async () => {
    const isValid = await trigger(["productId", "simAlias"]);

    if (!isValid) {
      return;
    }

    setAllowedMaxStep(partnerAddDeviceStepMapping.quantity.step);
    navigate(partnerAddDeviceStepPaths.quantity);
  };

  const handleBack = () => {
    navigate(partnerAddDeviceStepPaths["sim-type"]);
  };

  return (
    <div className="flex w-full flex-col gap-6">
      <RateSelection />

      <StepFlowNavigation
        primaryButton={
          <Button
            variant="primary"
            disabled={!productId || !simAlias}
            onClick={() => void handleContinue()}
          >
            {t("Common.label.forward")}
          </Button>
        }
        secondaryButton={
          <Button variant="secondary" onClick={handleBack}>
            {t("Common.label.back")}
          </Button>
        }
      />
    </div>
  );
};
